import React from 'react';

import { CustomButtonColor } from '../../../../UiComponentsLibrary/CustomButton/constants/CustomButtonColor';
import { ART_EVENT_STATUS } from '../../../../EditArtEvent/constants/artEventStatus';
import { canUserEdit } from '../../../../Shared/utils/helpers';

export interface ButtonConfig {
  id: string;
  text: string;
  backgroundColor: string;
  handleOnClickCb?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  tooltip?: string;
}

export interface CreateButtonConfigParams {
  translate: (key: string, options?: Record<string, unknown>) => string;
  handleCreateBookingClick?: () => void;
  handleActiveBookingsClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  handleCancelledBookingsClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  isCreateBookingDisabled?: boolean;
  artEventId?: string;
  artEventStatus?: string;
  userPermissions?: string[] | null;
  isPrivilegedMode?: boolean;
}

export const createButtonConfig = ({
  translate,
  handleCreateBookingClick,
  handleActiveBookingsClick,
  handleCancelledBookingsClick,
  isCreateBookingDisabled,
  artEventId,
  artEventStatus,
  userPermissions,
  isPrivilegedMode = false,
}: CreateButtonConfigParams): { buttonConfig: ButtonConfig[] } => {
  const canEdit = canUserEdit(userPermissions);
  const isFrozenBlocked = artEventStatus === ART_EVENT_STATUS.FROZEN && !isPrivilegedMode;

  const createBookingTooltipMsg = !canEdit
    ? translate('no-edit-permission-tooltip')
    : isCreateBookingDisabled
      ? isFrozenBlocked
        ? translate('art-event-frozen-tooltip')
        : artEventId
          ? translate('missing-inventory-tooltip')
          : translate('select-art-event-tooltip')
      : undefined;

  const buttons: ButtonConfig[] = [
    {
      id: 'all-booking',
      text: 'active-bookings-button',
      backgroundColor: CustomButtonColor.activeBookings,
      handleOnClickCb: handleActiveBookingsClick,
    },
    {
      id: 'cancelled-booking',
      text: 'cancelled-booking-button',
      backgroundColor: CustomButtonColor.cancelledBooking,
      handleOnClickCb: handleCancelledBookingsClick,
    },
    {
      id: 'create-booking',
      text: 'create-booking-button',
      backgroundColor: CustomButtonColor.createBooking,
      handleOnClickCb: handleCreateBookingClick,
      disabled: !canEdit || isCreateBookingDisabled,
      tooltip: createBookingTooltipMsg,
    },
  ];

  return { buttonConfig: buttons };
};
